module.exports = __webpack_public_path__ + "static/media/Amez.8cf0098b.svg";